function NavItem({ onClick, isActive, children }) {
  return <div className={`nav-item ${isActive ? 'is-active' : ''}`} onClick={onClick}>
    {children}
  </div>
}

export default NavItem
